var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLiveness(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 5.3125H8.5C7.65462 5.3125 6.84387 5.64833 6.2461 6.2461C5.64833 6.84387 5.3125 7.65462 5.3125 8.5V10.625M23.375 5.3125H25.5C26.3454 5.3125 27.1561 5.64833 27.7539 6.2461C28.3517 6.84387 28.6875 7.65462 28.6875 8.5V10.625M28.6875 23.375V25.5C28.6875 26.3454 28.3517 27.1561 27.7539 27.7539C27.1561 28.3517 26.3454 28.6875 25.5 28.6875H23.375M10.625 28.6875H8.5C7.65462 28.6875 6.84387 28.3517 6.2461 27.7539C5.64833 27.1561 5.3125 26.3454 5.3125 25.5V23.375",
    stroke: "currentColor",
    strokeWidth: 2.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9583 12.4844C18.9583 13.1448 18.696 13.7782 18.2289 14.2452C17.7619 14.7122 17.1285 14.9746 16.4681 14.9746C15.8076 14.9746 15.1742 14.7122 14.7072 14.2452C14.2402 13.7782 13.9779 13.1448 13.9779 12.4844C13.9779 11.8239 14.2402 11.1905 14.7072 10.7235C15.1742 10.2565 15.8076 9.99414 16.4681 9.99414C17.1285 9.99414 17.7619 10.2565 18.2289 10.7235C18.696 11.1905 18.9583 11.8239 18.9583 12.4844ZM11.4883 21.8596C11.5096 20.553 12.0437 19.3071 12.9752 18.3906C13.9068 17.4741 15.1613 16.9605 16.4681 16.9605C17.7749 16.9605 19.0294 17.4741 19.9609 18.3906C20.8925 19.3071 21.4266 20.553 21.4479 21.8596C19.8856 22.576 18.1868 22.9457 16.4681 22.9434C14.6911 22.9434 13.0043 22.5555 11.4883 21.8596Z",
    stroke: "currentColor",
    strokeWidth: 1.80625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLiveness);
export default __webpack_public_path__ + "static/media/icon-liveness.88d8dd75a05301240cfdfa8ab5ef2a8c.svg";
export { ForwardRef as ReactComponent };